/* Lunai gift note (posvetilo) — one document-level listener for the cart
   drawer's per-line editors. Lives as a global asset (NOT inline in the
   snippet) because the drawer body is re-rendered via the Section
   Rendering API after every add, and injected <script> tags never
   execute — the R2.2 root cause of silently swallowed notes. */
(function () {
  if (window.lunaiGiftNote) return;
  window.lunaiGiftNote = true;

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-gn-toggle]');
    if (toggle) {
      var wrap = toggle.closest('[data-gn]').querySelector('[data-gn-wrap]');
      if (!wrap) return;
      var opening = wrap.hidden;
      wrap.hidden = !opening;
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        wrap.classList.add('lu-reveal');
        var ta = wrap.querySelector('.gn-ta');
        if (ta) ta.focus();
      } else {
        wrap.classList.remove('lu-reveal');
      }
      return;
    }
    var save = e.target.closest('[data-gn-save]');
    if (!save || save.classList.contains('is-busy')) return;
    var wrap = save.closest('[data-gn-wrap]');
    var status = wrap.querySelector('[data-gn-status]');
    var ta = wrap.querySelector('.gn-ta');
    var props = {};
    try { props = JSON.parse(wrap.getAttribute('data-props') || '{}'); } catch (_) {}
    /* Liquid serializes EMPTY properties as [] — normalize to an object. */
    if (!props || typeof props !== 'object' || Array.isArray(props)) props = {};
    props['Posvetilo'] = ta.value.trim();
    save.classList.add('is-busy');
    save.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    var url = (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        /* data-line carries item.key, never a position — a positional line
           number could hit a re-indexed neighbour mid-mutation */
        id: wrap.getAttribute('data-line'),
        quantity: Number(wrap.getAttribute('data-qty')),
        properties: props
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (cartData) {
        /* Saving properties ROTATES this line's key (keys hash the line's
           properties — shopify.dev), so every attribute still holding the
           old key would 404 on its next request. Rewrite them from the
           response; when the line can't be singled out (e.g. Shopify
           merged two now-identical lines) ask the cart section for a full
           resync instead. */
        var oldKey = wrap.getAttribute('data-line');
        var items = (cartData && cartData.items) || [];
        var stillThere = items.some(function (it) { return it.key === oldKey; });
        if (!stillThere) {
          var domKeys = [].map.call(document.querySelectorAll('[data-gn-wrap][data-line]'), function (el) {
            return el.getAttribute('data-line');
          });
          var fresh = items.filter(function (it) { return domKeys.indexOf(it.key) === -1; });
          if (fresh.length === 1) {
            [].forEach.call(document.querySelectorAll('[data-line="' + oldKey + '"]'), function (el) {
              el.setAttribute('data-line', fresh[0].key);
            });
            [].forEach.call(document.querySelectorAll('[data-co-remove="' + oldKey + '"]'), function (el) {
              el.setAttribute('data-co-remove', fresh[0].key);
            });
          } else {
            document.dispatchEvent(new CustomEvent('lunai:cart-resync'));
          }
        }
        wrap.setAttribute('data-props', JSON.stringify(props));
        if (status) status.textContent = wrap.getAttribute('data-saved-text');
        var preview = wrap.closest('[data-gn]').querySelector('[data-gn-preview]');
        if (preview) {
          var v = props['Posvetilo'];
          preview.textContent = v
            ? (v.length > 34 ? v.slice(0, 31) + '…' : v)
            : (preview.getAttribute('data-gn-empty-label') || preview.textContent);
          preview.classList.toggle('gn-preview', !!v);
        }
      })
      .catch(function () {
        if (status) status.textContent = wrap.getAttribute('data-error-text');
      })
      .then(function () {
        save.classList.remove('is-busy');
        save.removeAttribute('aria-busy');
      });
  });
})();
